const playFree = () => {
  if(window.nexon){
    var game = "SVG011";
    window.nexon.play(game);
    // const redirectUrl = location.origin + location.pathname;
    // window.nexon.gnt.signupGlobal(redirectUrl, 10100);
  }
}
export default { 
  playFree
}